import { selectAccountFormLoading, selectuserAccountDetails } from 'Selector/CompaniesSelector';
import { actions } from 'Slice/CompaniesSlice';
import { getCurrentTime, valueToObject } from 'Utils/UtilityFunctions';
import {
  SecondaryColor, maxWidth, primaryFont, retina, wMBold, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { actions as UiAction } from 'Slice/UISlice';

const Wrapper = styled.div`
&.noHistoryPage {
  .create-new-smart-plan {
    &.disabled{
      min-width:300px;
    }
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 28px;
    border-radius: 12px;
    height: 60px;
    text-align: center;
    font-size: 18px;
    margin-top: 16px;
    sup {
      font-size: 62%;
    }
    @media all and (max-width: ${maxWidth}), ${retina} {
      height: 48px;
      padding: 4px 28px;
      font-size: 16px;
      font-weight: ${wMedium};
    }
  }
}
  .create-new-smart-plan {
     &.disabled{
      min-width: 100%;
    }
    position: absolute;
    bottom: 0;
    left: 0;
    font-family: ${primaryFont};
    font-weight: ${wMBold};
    font-size: 16px;
    line-height: 22px;
    background-color: ${SecondaryColor};
    color: #fff;
    cursor: pointer;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 14px;
      line-height: 18px;
    }
    sup {
      font-size: 10px;
      top: -7px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 9px;
      }
    }
    .ant-spin {
      position: absolute;
      .ant-spin-dot{
        .ant-spin-dot-item {
          background-color: #fff;
        }
      }
    }
  }
`;
type Props = {
  companyId: number,
  noHistoryStyle?: boolean,
  handleAllowPop?: () => void,
} & typeof defaultProps;

const defaultProps = {
  noHistoryStyle: false,
  handleAllowPop: () => { },
};
const CreateNewSapBtn = function CreateNewSapBtn(props: Props) {
  const { companyId, noHistoryStyle, handleAllowPop } = props;
  const [sapLimit, setSapLimit] = useState(false);
  const limitPopup = useSelector(selectuserAccountDetails);
  const loading = useSelector(selectAccountFormLoading);
  const startTime = getCurrentTime();

  const dispatch = useDispatch();

  const toggleShowPopup = () => {
    dispatch(actions.getAccountPlanForm({ companyId }));
    dispatch(actions.setNewAccountPlan());
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('create_new_account_plan', startTime, {}),
    ));
    handleAllowPop();
    setSapLimit(true);
    dispatch(UiAction.createNewSapFromGenerationScreen(true));
  };

  useEffect(() => {
    if (sapLimit && limitPopup?.showPlanPopup === 3) {
      dispatch(actions.setAccountPlanDrawerOpen(false));
      dispatch(actions.setShowLimitPopupSAP(true));
      handleAllowPop();
      setSapLimit(false);
    }
  }, [sapLimit, limitPopup?.showPlanPopup]);

  return (
    <Wrapper className={classNames({ noHistoryPage: noHistoryStyle })}>
      <span
        tabIndex={0}
        role="button"
        className={classNames('create-new-smart-plan', { disabled: loading })}
        onClick={() => toggleShowPopup()}
        onKeyPress={() => toggleShowPopup()}
      >
        <span className="text-decoration-smart"> Create New Smart Account Plan</span>
        <sup>TM</sup>
      </span>
    </Wrapper>
  );
};
CreateNewSapBtn.defaultProps = defaultProps;
export default CreateNewSapBtn;
